/* global videojs */

var POLL_INTERVAL_MS = 250;
var MAX_ATTEMPTS = 20;

/**
 * Attaches a videojs error handler to a player that adds .has-video-error to the banner root.
 * @param {string} playerId - The video-js element ID
 * @param {jQuery} $banner - The root .homepage-video-banner jQuery element
 */
function attachErrorHandler(playerId, $banner) {
    videojs.getPlayer(playerId).ready(function () {
        if (this.error()) {
            $banner.addClass('has-video-error');
            return;
        }
        this.on('error', function () {
            $banner.addClass('has-video-error');
        });
    });
}

/**
 * Polls until window.videojs is available AND all players are registered in the
 * video.js registry (loaded by the Brightcove inline script), then attaches error
 * handlers to each player in every .homepage-video-banner.
 * Called at page load via processInclude in main.js. Exits early when no
 * .homepage-video-banner elements are present on the page.
 *
 * Polling checks player registration (not just window.videojs) because Brightcove
 * registers players asynchronously — videojs.getPlayer() returns undefined if called
 * before initialization completes, which would throw a TypeError.
 */
function init() {
    var $banners = $('.homepage-video-banner');
    if (!$banners.length) {
        return;
    }

    // Pre-collect all (id, $banner) pairs so the poll can verify registration per player
    var players = [];
    $banners.each(function () {
        var $banner = $(this);
        $banner.find('video-js[id]').each(function () {
            players.push({ id: this.id, $banner: $banner });
        });
    });

    if (!players.length) {
        return;
    }

    var attempts = 0;

    var poll = setInterval(function () {
        attempts++;
        var allRegistered = window.videojs && players.every(function (p) {
            return videojs.getPlayer(p.id);
        });

        if (allRegistered || attempts >= MAX_ATTEMPTS) {
            clearInterval(poll);
            if (!allRegistered) {
                // eslint-disable-next-line no-console
                console.warn('homepageVideoBanner: videojs unavailable or players not registered after timeout — video error fallback will not be active');
                return;
            }
            players.forEach(function (p) {
                attachErrorHandler(p.id, p.$banner);
            });
        }
    }, POLL_INTERVAL_MS);
}

module.exports = {
    init: init
};
